import { createFeatureSelector, createSelector } from '@ngrx/store';
import { OnboardingState } from './onboarding.state';

export const getOnboardingFeatureState = createFeatureSelector('onboarding');

export const selectInformation = createSelector(
  getOnboardingFeatureState,
  (state: OnboardingState) => state.information
);

export const selectIsLoading = createSelector(
  getOnboardingFeatureState,
  (state: OnboardingState) => state.isLoading
);

export const selectIsError = createSelector(
  getOnboardingFeatureState,
  (state: OnboardingState) => state.error
);

export const selectAuth10tix = createSelector(
  getOnboardingFeatureState,
  (state: OnboardingState) => state.auth10tix
);

export const selectCustomerValidation = createSelector(
  getOnboardingFeatureState,
  (state: OnboardingState) => state.customerValidation
);

export const selectStepInfo = createSelector(
  getOnboardingFeatureState,
  (state: OnboardingState) => state.stepInfo
);
